import React from "react";
import { List } from "antd";
import VehicleDescription from "@/components/VehicleDescription";
const VehiclesSummaryList = ({ shipment }) => {
    const { vehicles } = shipment ?? [];
    return (React.createElement("div", null,
        React.createElement("span", { style: { fontSize: 16, fontWeight: "bold" } }, `${vehicles.length} Vehicle${vehicles.length > 1 ? "s" : ""}`),
        React.createElement(List, { dataSource: vehicles, rowKey: item => item.id, renderItem: item => (React.createElement(List.Item, null,
                React.createElement(List.Item.Meta, { title: React.createElement(VehicleDescription, { vehicle: {
                            ...item,
                            shipment: {
                                trailerType: shipment.trailerType,
                                availableAt: shipment.availableAt,
                            },
                            gatePassType: item.gatePassType,
                            gatePassUrl: item.gatePassUrl,
                        }, withTags: true }) }))) })));
};
export default VehiclesSummaryList;
